import { DefaultService } from '@/services/DefaultService';

export default class UnidadeMedidaAreaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(unidademedidaarea) {
        return this._http.post(`${this._env}/agro/areameasurementunit`, unidademedidaarea, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/areameasurementunit/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/areameasurementunit/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/areameasurementunit.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(undmedidaarea) {
        return this._http.post(`${this._env}/agro/areameasurementunit/updatesituation`, undmedidaarea, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/agro/areameasurementunit/getcombo.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}